import axios from "axios";
import useToaster from "./useToaster";
import { useDispatch } from "react-redux";
import { isLoadingStateReducer } from "../Redux/Slice/loginSlice";

const useDownloadFile = () => {
  const mimeTypes = {
    avi: "video/avi",
    m4a: "audio/m4a",
  };

  const { showToast } = useToaster();
  const dispatch = useDispatch();

  const downloadFile = async (
    downloadFilePath,
    downloadFileName = "download",
    fileType
  ) => {
    showToast("Downloading started", "info", true);
    dispatch(isLoadingStateReducer(true));

    const mimeType = mimeTypes[fileType];

    try {
      const response = await axios.get(downloadFilePath, {
        responseType: "blob",
      });
      const blob = new Blob([response.data], { type: mimeType });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = downloadFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      dispatch(isLoadingStateReducer(false));
      showToast("File downloaded successfully", "success", true);
    } catch (error) {
      dispatch(isLoadingStateReducer(false));
      showToast("Error occurred while downloading the file", "error", true);
    }
  };

  return { downloadFile };
};

export default useDownloadFile;
